import type LocalStorageKeys from "src/types/LocalStorageKeys";
import userTypes from "src/types/userTypes";

const setUserType = (value: string) => {
    switch (value) {
        case "Artist":
            localStorage.setItem("userType", userTypes.Artist);
            return;
        case "User":
            localStorage.setItem("userType", userTypes.User);
            return;
        case "Guest":
            localStorage.setItem("userType", userTypes.Guest);
            return;
        default:
            throw new Error("!userTypeの値が不正です!");
    }
};

const localStorageManager = {
    getItem: (key: keyof LocalStorageKeys) => {
        const getItem = localStorage.getItem(`${key}`);

        // getItemがnullまたはキーが存在するが空の場合はnullを返す
        if (getItem === "" || getItem === null) return null;

        return getItem;
    },
    setItem: (key: keyof LocalStorageKeys, value: string) => {
        if (key === "userType") {
            setUserType(value);
        } else {
            localStorage.setItem(`${key}`, value);
        }
    },
    removeItem: (key: keyof LocalStorageKeys) => {
        localStorage.removeItem(`${key}`);
    },
    clearAll: () => {
        localStorage.clear();
    },
};

export default localStorageManager;
